import { SiteConnectionHistoryFilter } from '@occc/graphql';

import { getDateRange } from '@occc/ui-forms';
import { ConnectionHistoryFilterFormValues } from './connection-history-filter.types';

export const connectionHistoryFilterToGqlFilter = (
  input: ConnectionHistoryFilterFormValues,
): SiteConnectionHistoryFilter => {
  let baseFilter: SiteConnectionHistoryFilter = {};
  if (input.connectionStatusEquals) {
    baseFilter.connectionStatusEquals = input.connectionStatusEquals;
  }
  if (input.disconnectActionContains?.length) {
    baseFilter.disconnectActionContains = input.disconnectActionContains;
  }

  if (input.connectionDurationSeconds) {
    baseFilter[
      input.connectionDurationOperator === 'gte'
        ? 'connectionDurationInMillisecondsGreaterThan'
        : 'connectionDurationInMillisecondsLessThan'
    ] = input.connectionDurationSeconds * 1000;
  }

  if (input.lastConnectedAt) {
    baseFilter = {
      ...baseFilter,
      ...getDateRange(
        input.lastConnectedAt,
        'lastConnectDateFrom',
        'lastConnectDateTo',
        input.lastConnectDateFrom,
        input.lastConnectDateTo,
      ),
    };
  }
  if (input.lastDisconnectedAt) {
    baseFilter = {
      ...baseFilter,
      ...getDateRange(
        input.lastDisconnectedAt,
        'lastDisconnectDateFrom',
        'lastDisconnectDateTo',
        input.lastDisconnectDateFrom,
        input.lastDisconnectDateTo,
      ),
    };
  }

  return baseFilter;
};
